export default {"src":"/_next/static/media/star_green.0e63f98a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};